import React from 'react';
import styled from 'styled-components';
import { SlidePage } from '../index';
import { BodyContainer, ProgressBox, ProgressStat } from '../styles';
// import HorizontalBarChart from '../HorizontalBarChart';
import { polarColors } from '../constants';
import sportIcon from '../imgs/sport_icon.png';
import artIcon from '../imgs/art_icon.png';
import learnIcon from '../imgs/learn_icon.png';
import calculatorIcon from '../imgs/calculator_icon.png';
import brainIcon from '../imgs/brain_icon.png';
import bookIcon from '../imgs/book_icon.png';

export const ChartWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  width: 100%;
`;

// const getColor = value => {
//   if (value < 25) {
//     return greenScaleColors[4];
//   }
//   if (value < 50) {
//     return greenScaleColors[3];
//   }
//   if (value < 75) {
//     return greenScaleColors[1];
//   }
//   return greenScaleColors[0];
// };
const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const CreenciasHabilidadesSecond = ({ user, background, number }) => {
  const { ABIND_01, ABIND_02, ABIND_03, ABIND_04, ABIND_05, ABIND_06 } = user;
  const data = {
    NUMERICA: {
      dimension: 'NUMERICA',
      label: 'Habilidades Numéricas',
      value: (parseFloat(ABIND_01) / 5) * 100
    },
    VERBAL: {
      dimension: 'VERBAL',
      label: 'Habilidades Verbales',
      value: (parseFloat(ABIND_02) / 5) * 100
    },
    MEMORIA: {
      dimension: 'MEMORIA',
      label: 'Habilidades de Memoria',
      value: (parseFloat(ABIND_03) / 5) * 100
    },
    ARTISTICAS: {
      dimension: 'ARTISTICAS',
      label: 'Habilidades Artísticas',
      value: (parseFloat(ABIND_04) / 5) * 100
    },
    DEPORTIVAS: {
      dimension: 'DEPORTIVAS',
      label: 'Habilidades Deportivas',
      value: (parseFloat(ABIND_05) / 5) * 100
    },
    APRENDIZAJE: {
      dimension: 'APRENDIZAJE',
      label: 'Habilidades de Aprendizaje',
      value: (parseFloat(ABIND_06) / 5) * 100
    }
  };

  // console.log({ data });

  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>3.2. Creencias sobre habilidades específicas</h2>

          <p className='justified'>
            A continuación verás en{' '}
            <strong>
              qué áreas crees que sería más difícil para ti mejorar versus otras
              áreas donde crees que es posible mejorar invirtiendo tiempo y
              esfuerzo
            </strong>
            . Te proponemos reflexionar sobre qué hace que para ti un área sea
            más o menos fácil de mejorar, y a revisar cuidadosamente estas
            ideas.
          </p>

          {/* <ChartWrapper>
            <HorizontalBarChart user={user} />
          </ChartWrapper> */}
          <br />
          <div className='abilities-list'>
            <div className='ability-item'>
              <div className='ability-icon'>
                <img src={calculatorIcon} alt='icon' />
              </div>
              <div className='ability-progress'>
                <div className='progress-name'>{data.NUMERICA.label}</div>
                <ProgressBox
                  progress={data.NUMERICA.value}
                  backColor={() => getColor(100 - data.NUMERICA.value)}
                  style={{ margin: 0 }}
                >
                  <div className='progress'></div>
                </ProgressBox>
              </div>
              <div className='ability-result'>
                <ProgressStat>{data.NUMERICA.value.toFixed(0)}</ProgressStat>
              </div>
            </div>

            <div className='ability-item'>
              <div className='ability-icon'>
                <img src={bookIcon} alt='icon' />
              </div>
              <div className='ability-progress'>
                <div className='progress-name'>{data.VERBAL.label}</div>
                <ProgressBox
                  progress={data.VERBAL.value}
                  backColor={() => getColor(100 - data.VERBAL.value)}
                  style={{ margin: 0 }}
                >
                  <div className='progress'></div>
                </ProgressBox>
              </div>
              <div className='ability-result'>
                <ProgressStat>{data.VERBAL.value.toFixed(0)}</ProgressStat>
              </div>
            </div>

            <div className='ability-item'>
              <div className='ability-icon'>
                <img src={brainIcon} alt='icon' />
              </div>
              <div className='ability-progress'>
                <div className='progress-name'>{data.MEMORIA.label}</div>
                <ProgressBox
                  progress={data.MEMORIA.value}
                  backColor={() => getColor(100 - data.MEMORIA.value)}
                  style={{ margin: 0 }}
                >
                  <div className='progress'></div>
                </ProgressBox>
              </div>
              <div className='ability-result'>
                <ProgressStat>{data.MEMORIA.value.toFixed(0)}</ProgressStat>
              </div>
            </div>

            <div className='ability-item'>
              <div className='ability-icon'>
                <img src={artIcon} alt='icon' />
              </div>
              <div className='ability-progress'>
                <div className='progress-name'>{data.ARTISTICAS.label}</div>
                <ProgressBox
                  progress={data.ARTISTICAS.value}
                  backColor={() => getColor(100 - data.ARTISTICAS.value)}
                  style={{ margin: 0 }}
                >
                  <div className='progress'></div>
                </ProgressBox>
              </div>
              <div className='ability-result'>
                <ProgressStat>{data.ARTISTICAS.value.toFixed(0)}</ProgressStat>
              </div>
            </div>

            <div className='ability-item'>
              <div className='ability-icon'>
                <img src={sportIcon} alt='icon' />
              </div>
              <div className='ability-progress'>
                <div className='progress-name'>{data.DEPORTIVAS.label}</div>
                <ProgressBox
                  progress={data.DEPORTIVAS.value}
                  backColor={() => getColor(100 - data.DEPORTIVAS.value)}
                  style={{ margin: 0 }}
                >
                  <div className='progress'></div>
                </ProgressBox>
              </div>
              <div className='ability-result'>
                <ProgressStat>{data.DEPORTIVAS.value.toFixed(0)}</ProgressStat>
              </div>
            </div>

            <div className='ability-item'>
              <div className='ability-icon'>
                <img src={learnIcon} alt='icon' />
              </div>
              <div className='ability-progress'>
                <div className='progress-name'>{data.APRENDIZAJE.label}</div>
                <ProgressBox
                  progress={data.APRENDIZAJE.value}
                  backColor={() => getColor(100 - data.APRENDIZAJE.value)}
                  style={{ margin: 0 }}
                >
                  <div className='progress'></div>
                </ProgressBox>
              </div>
              <div className='ability-result'>
                <ProgressStat>{data.APRENDIZAJE.value.toFixed(0)}</ProgressStat>
              </div>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default CreenciasHabilidadesSecond;
